import { useEffect } from 'react';
import { useAuth } from '../auth/AuthProvider';

export const useAnalytics = () => {
  const { user } = useAuth();

  // Track user identification when user state changes
  useEffect(() => {
    if (user && window.va) {
      // Identify the user in Vercel Analytics
      window.va('identify', {
        userId: user.id,
        email: user.email,
        userType: 'registered'
      });
    }
  }, [user]);

  // Custom event tracking functions
  const trackEvent = (eventName, properties = {}) => {
    if (window.va) {
      window.va('track', eventName, {
        ...properties,
        userId: user?.id,
        userType: user ? 'registered' : 'anonymous'
      });
    }
  };

  const trackPageView = (pageName) => {
    trackEvent('page_view', {
      page: pageName,
      timestamp: new Date().toISOString()
    });
  };

  const trackUserAction = (action, details = {}) => {
    trackEvent('user_action', {
      action,
      ...details,
      timestamp: new Date().toISOString()
    });
  };

  const trackReturnVisit = () => {
    if (user) {
      trackEvent('return_visit', {
        userId: user.id,
        email: user.email,
        lastVisit: localStorage.getItem(`lastVisit_${user.id}`),
        visitCount: parseInt(localStorage.getItem(`visitCount_${user.id}`) || '0') + 1
      });
      
      // Update visit tracking
      localStorage.setItem(`lastVisit_${user.id}`, new Date().toISOString());
      localStorage.setItem(`visitCount_${user.id}`, 
        (parseInt(localStorage.getItem(`visitCount_${user.id}`) || '0') + 1).toString()
      );
    }
  };

  return {
    trackEvent,
    trackPageView,
    trackUserAction,
    trackReturnVisit,
    user
  };
}; 